module.exports = __webpack_public_path__ + "img/img-event-tab-02.c54f8835.png";